import {APP_URLS} from "./urls";
import {ArrowRightLeft, House, LaptopMinimal, Users, Trophy, UserRound} from "lucide-react";

export const nav_items = [
    {
        id: 'home',
        path: APP_URLS.routes.main,
        title: 'Dashboard',
        icon: <House/>
    },
    {
        id: 'transactions',
        path: APP_URLS.routes.transactions,
        title: 'Transactions',
        icon: <ArrowRightLeft/>
    },{
        id: 'referrals',
        path: APP_URLS.routes.referrals,
        title: 'Referrals',
        icon: <Users/>
    },{
        id: 'leader_board',
        path: APP_URLS.routes.leader_board,
        title: 'Leader Board',
        icon: <Trophy/>
    },{
        id: 'hardware',
        path: APP_URLS.routes.hardware,
        title: 'Hardware',
        icon: <LaptopMinimal/>
    },{
        id: 'profile',
        path: APP_URLS.routes.profile,
        title: 'Profile',
        icon: <UserRound/>
    }
]